<template>
  <div>
    <div class="Cagrilar">
      <div class="Cagri" :class="s.Kisi?'Bilinen':'Bilinmeyen'" v-for="(s,index) in SantralDurum">
        <a class="Kapat" @click="SantralDurum.splice(index, 1)"><i class="el-icon-circle-close"></i></a>
        <div class="Tarih"><i class="el-icon-stopwatch"></i> {{s.Tarih}}</div>
        <div class="Telefon"><i class="el-icon-phone-outline"></i> {{s.Telefon}}</div>
        <div class="Kisi" @click="$router.push('/yonetim/kisi/'+s.Kisi.Kisi_id)" v-if="s.Kisi">
          <div class="Adi"><i class="el-icon-user-solid"></i> {{s.Kisi.AdSoyad}}</div>
          <div class="Bina"><i class="el-icon-s-home"></i> {{s.Kisi.Adi}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['SantralDurum']
  }
</script>

<style scoped>
  .Cagrilar {
    position: fixed;
    right: 20px;
    bottom: 10px;
    z-index: 9999;
  }

  .Cagrilar .Cagri.Bilinen {
    background: #4185f3;
  }

  .Cagrilar .Cagri.Bilinmeyen {
    background: #f4b400;
  }

  .Cagrilar .Cagri {
    width: 200px;
    padding: 10px;
    border-radius: 4px;
    position: relative;
    color: #fff;
    margin-bottom: 20px;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.1);
  }

  .Cagrilar .Cagri.Bilinen .Ikon {
    background: #00c391;
  }

  .Cagrilar .Cagri.Bilinmeyen .Ikon {
    background: #f4b400;
  }

  .Cagrilar .Cagri .Ikon {

    font-size: 20px;
    position: absolute;
    left: -35px;
    padding: 10px;
    border-radius: 100% 0 0 100%;
    width: 40px;
    height: 40px;
    line-height: 25px;
    top: 0;
  }

  .Cagrilar .Cagri .Ikon i {
  }

  .Cagrilar .Cagri .Tarih {
    font-size: 10px;
  }

  .Cagrilar .Cagri .Telefon {
    font-size: 12px;
  }

  .Cagrilar .Cagri .Kapat {
    right: 10px;
    position: absolute;
    color: #ffffff;
  }

  .Cagrilar .Cagri .Kisi {
    cursor: pointer;
    font-size: 12px;
  }

  .Cagrilar .Cagri .Adi {
  }

  .Cagrilar .Cagri .Bina {
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/SantralCagriIzleme.vue